// import { roleNames } from '@/config'

const ManaLayout = () => import(/* webpackChunkName: "mana" */ '@/layout/ManaLayout')

// 设备管理
const DeviceMana = () => import(/* webpackChunkName: "deviceMana" */ '@/views/ManaMode/DeviceMana')
const InstallDevice = () => import(/* webpackChunkName: "deviceMana" */ '@/views/ManaMode/DeviceMana/installDevice')
const NotInstallDevice = () => import(/* webpackChunkName: "deviceMana" */ '@/views/ManaMode/DeviceMana/notInstallDevice')

// 报警记录
const WarningRecord = () =>
  import(/* webpackChunkName: "warningRecord" */ '@/views/ManaMode/WarningRecord')

// 系统管理-用户管理
const userManagement = () => import(/* webpackChunkName: "systemManagement" */ '@/views/ManaMode/systemManagement/userManagement')
// 系统管理-单位管理
const DepartmentManagement = () => import(/* webpackChunkName: "systemManagement" */ '@/views/ManaMode/systemManagement/DepartmentManagement')
// 系统管理-系统日志
const LoginLog = () => import(/* webpackChunkName: "systemManagement" */ '@/views/ManaMode/systemManagement/loginLog')

// 后台管理-设备列表
// const DeviceList = () => import(/* webpackChunkName: "deviceManagement" */ '@/views/ManaMode/deviceManagement/deviceList')

// 后台管理-设备管理-box
const DeviceManaBack = () => import(/* webpackChunkName: "deviceManagement" */ '@/views/ManaMode/deviceManagement/deviceMana')
// 后台管理-设备管理-入库设备
const OutWarehousing = () => import(/* webpackChunkName: "deviceManagement" */ '@/views/ManaMode/deviceManagement/deviceMana/outWarehousing')
// 后台管理-设备管理-出库设备
const Warehousing = () => import(/* webpackChunkName: "deviceManagement" */ '@/views/ManaMode/deviceManagement/deviceMana/warehousing')

// 后台管理-分组管理
// const EquipmentGroup = () =>
//   import(/* webpackChunkName: "systemManagement" */ '@/views/ManaMode/deviceManagement/equipmentGroup')

export default [
  {
    path: '/manaMode',
    component: ManaLayout,
    meta: {
      name: '管理模式',
      hideInMenu: true,
      icon: 'onlineMonitoring',
      topNavActivePath: '/manaMode',
    },
    children: [
      {
        path: '',
        name: 'deviceMana',
        component: DeviceMana,
        meta: {
          nav: true,
          hideInMenu: false,
          hideChildrenInMenu: true,
          name: '设备管理',
          title: '设备管理',
          authority: true,
          icon: 'deviceMana',
        },
        redirect: { name: 'installDevice' },
        children: [
          {
            path: 'installDevice',
            name: 'installDevice',
            component: InstallDevice,
            meta: { authority: true },
          },
          {
            path: 'unintall',
            name: 'notInstallDevice',
            component: NotInstallDevice,
            meta: { authority: true },
          },
        ],
      },
      {
        path: 'warningRecord',
        name: 'warningRecord',
        component: WarningRecord,
        meta: { nav: true, name: '报警信息', authority: true, icon: 'warnMana' },
      },
    ],
  },
  {
    path: '/manaMode',
    name: 'manaMode',
    component: ManaLayout,
    redirect: {
      name: 'userManagement',
    },
    meta: {
      name: '系统管理',
      title: '系统管理',
      nav: true,
      authority: true,
      icon: 'systemMana',
    },
    children: [
      {
        path: 'user-management',
        name: 'userManagement',
        component: userManagement,
        meta: {
          name: '用户管理',
          title: '用户管理',
          authority: ['DFSJ_ADMINER', 'SYSTEM_ADMINER'],
        },
      },
      {
        path: 'department-management',
        name: 'DepartmentManagement',
        component: DepartmentManagement,
        meta: {
          name: '单位管理',
          title: '单位管理',
          authority: ['DFSJ_ADMINER', 'SYSTEM_ADMINER'],
        },
      },
      {
        path: 'loginLog',
        name: 'LoginLog',
        component: LoginLog,
        meta: {
          name: '登录日志',
          title: '登录日志',
          authority: ['DFSJ_ADMINER', 'SYSTEM_ADMINER'],
        },
      },
    ],
  },
  {
    path: '/manaMode',
    name: 'manaMode',
    component: ManaLayout,
    meta: {
      name: '后台管理',
      title: '后台管理',
      icon: 'systemMana',
      nav: true,
      authority: ['DFSJ_ADMINER'],
    },
    topNavActivePath: '/manaMode',
    children: [
      {
        path: '',
        name: 'deviceManaBack',
        component: DeviceManaBack,
        meta: {
          nav: true,
          hideInMenu: false,
          hideChildrenInMenu: true,
          name: '设备管理',
          title: '设备管理',
          authority: ['DFSJ_ADMINER'],
        },
        topNavActivePath: '',
        redirect: { name: 'warehousing' },
        children: [
          {
            path: 'outWarehousing',
            name: 'outWarehousing',
            component: OutWarehousing,
            meta: { authority: ['DFSJ_ADMINER'] },
          },
          {
            path: 'warehousing',
            name: 'warehousing',
            component: Warehousing,
            meta: { authority: ['DFSJ_ADMINER'] },
          },
        ],
      },
      // {
      //   path: 'equipmentGroup',
      //   name: 'equipmentGroup',
      //   component: EquipmentGroup,
      //   meta: {
      //     name: '分组管理',
      //     title: '分组管理',
      //     authority: ['DFSJ_ADMINER']
      //   },
      // },
    ],
  },
]
